import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ""
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase App Check with reCAPTCHA v3
if (typeof window !== 'undefined') {
  const appCheckToken = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  if (appCheckToken) {
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(appCheckToken),
        isTokenAutoRefreshEnabled: true
      });
      console.log('App Check initialized');
    } catch (error) {
      console.error('App Check initialization error:', error);
    }
  } else {
    console.log('App Check token not found');
  }
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;